import { useTranslation } from "react-i18next";

import { useSelectedLocation } from "components";
import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { ChecklistsDashboardQueryKeys } from "modules/ChecklistsDashboard/queryKeys";
import { getChecklistById } from "modules/ChecklistsDashboard/util";
import { ApiInstance } from "utils/Api";

import type { ChecklistID, DealerID } from "models";

type DuplicateChecklistPayload = {
  checklist_id: ChecklistID;
  dealer_id: DealerID;
};

export const useDuplicateChecklistMutation = () => {
  const { t } = useTranslation();

  const { selectedLocation } = useSelectedLocation();

  return useTypedMutation<DuplicateChecklistPayload, ChecklistID>({
    mutationFn: async payload => (await ApiInstance.post("/checklists/duplicate", payload, ENV.dealerBaseURL)).data.checklist_id,
    onSuccess: ({ checklist_id, dealer_id }, id) => {
      const dealerChecklists = typedQueryClient.getQueryData(ChecklistsDashboardQueryKeys.dealerChecklists(dealer_id)) ?? [];
      if (dealerChecklists.some(dc => dc.id === id)) return;

      const sourceChecklist = getChecklistById(checklist_id, dealer_id, selectedLocation?.id);
      if (!sourceChecklist) return;

      typedQueryClient.setQueryData(ChecklistsDashboardQueryKeys.dealerChecklists(dealer_id), [
        { ...sourceChecklist, id, dealer_id, name: `${t("v8_copy_of", "Copy of")} ${sourceChecklist.name}` },
        ...dealerChecklists
      ]);
    }
  });
};
